export default __webpack_public_path__ + "static/media/thailand.6a2e8a3d.svg";